<template>
  <v-row no-gutters>
    <v-col cols="12">
      <div class="text-h6 titleLight--text">Edit Asset Details</div>
      <div class="primaryGrey--text" v-if="!is_h2scan_user">Asset ID : {{ asset_model.DeviceID }}</div>
      <div class="primaryGrey--text" v-else>XFMR ID : {{ asset_model.AssetID }}</div>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row class="py-6">
          <v-col cols="6">
            <v-text-field
              color="primaryDark"
              dense
              v-model="asset_model.TransformerName"
              label="Transformer Name"
              :counter="50"
              :rules="maxRule(50, false)"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              color="primaryDark"
              dense
              v-model="asset_model.AssetID"
              label="Asset ID"
              :counter="50"
              :rules="maxRule(50, false)"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              color="primaryDark"
              dense
              v-model="asset_model.TransformerNo"
              label="Transformer No."
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              color="primaryDark"
              dense
              v-model="asset_model.TransformerRating"
              label="Transformer Rating (kVA)"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              color="primaryDark"
              dense
              v-model="asset_model.CurrentLat"
              :rules="numberRule([-90, 90], false)"
              label="Latitude"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              color="primaryDark"
              dense
              v-model="asset_model.CurrentLng"
              :rules="numberRule([-180, 180], false)"
              label="Longitude"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-select
              dense
              color="primaryDark"
              v-model="asset_model.ConnectionType"
              :items="page_content.ConnectionType"
              label="Connection Type"
            ></v-select>
          </v-col>
          <v-col cols="6" v-if="!is_h2scan_user">
            <v-text-field
              color="primaryDark"
              dense
              v-model="asset_model.ConnectedMPRNs"
              :rules="numberRule([0, 500], false)"
              label="Connected MPRNs"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              color="primaryDark"
              dense
              v-model="asset_model.Comment"
              label="Comments"
              :rules="maxRule(500, false)"
              :counter="500"
              append-outer-icon="mdi-comment"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="font-weight-bold titleLight--text">Update Feeder Names </v-col>
          <!-- {{ asset_model.FeedersName }} -->
          <v-col cols="4" v-for="(val, indx) in feeder_names" :key="`feeder_label_${indx}`">
            <v-text-field
              color="primaryDark"
              dense
              v-model="asset_model.FeedersName[indx]"
              :label="`Feeder ${indx + 1}`"
              :rules="maxRule(50, false)"
              :counter="50"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-spacer></v-spacer>
          <v-col cols="auto">
            <v-btn dense outlined class="mr-2 bold" @click="$emit('cancel')">Cancel</v-btn>
            <v-btn dense color="primary" @click="validate('save', asset_model)" class="bold" :disabled="!valid"
              >Save</v-btn
            >
          </v-col>
        </v-row>
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
import { content } from "../../config/config.js";

export default {
  name: "EditScvDetails",
  props: { asset_data: Object },
  watch: {},
  data: function () {
    return {
      valid: true,
      page_content: null,
      maxAndRequiredRule: [
        (v) => !!v || "This field is required",
        (v) => (v && v.length <= 50) || "Must be less than 50 characters",
      ],
      requiredRule: [(v) => !!v || "This field is required"],
      date_picker: false,
    };
  },
  created() {
    this.page_content = content;
  },
  mounted() {},
  methods: {
    maxRule: function (characters, isRequired) {
      return isRequired
        ? [
            (v) => !!v || "This field is required",
            (v) => (v && v.length <= characters) || `Must be less than ${characters} characters`,
          ]
        : [(v) => !v || (v && v.length <= characters) || `Must be less than ${characters} characters`];
    },

    numberRule: function (digits, isRequired) {
      if (typeof digits == "number") {
        return isRequired
          ? [(v) => !!v || "This field is required", (v) => (v && v <= digits) || `Must be less than ${digits}`]
          : [(v) => !v || (v && v <= digits) || `Must be less than ${digits}`];
      } else {
        return isRequired
          ? [
              (v) => !!v || "This field is required",
              (v) =>
                (v && v <= digits[1] && v >= digits[0]) ||
                `Must be less than ${digits[1]} and greater than ${digits[0]}`,
            ]
          : [(v) => !v || (v && v <= digits[1] && v >= digits[0]) || `Must be less than ${digits}`];
      }
    },
    validate: function (event, obj) {
      if (this.$refs.form.validate()) {
        // obj.InstallationDate =
        //   obj.InstallationStatus &&
        //   obj.InstallationStatus.toLowerCase() == "installed"
        //     ? obj.InstallationDate
        //     : null;
        this.$emit(event, obj);
      }
    },
  },
  computed: {
    asset_model: function () {
      return {
        TransformerName: (this.asset_data && this.asset_data.item.TransformerName) || null,
        AssetID: (this.asset_data && this.asset_data.item.AssetID) || "",
        TransformerNo: (this.asset_data && this.asset_data.item.TransformerNo) || null,
        TransformerRating: (this.asset_data && this.asset_data.item.TransformerRating) || null,
        CurrentLat: (this.asset_data && this.asset_data.item.CurrentLat) || null,
        DeviceID: (this.asset_data && this.asset_data.item.DeviceID) || null,
        CurrentLng: (this.asset_data && this.asset_data.item.CurrentLng) || null,
        ActiverFeeders: (this.asset_data && this.asset_data.item.ActiverFeeders) || null,
        FeedersName: (this.asset_data && this.asset_data.item.FeedersName) || [],
        Comment: (this.asset_data && this.asset_data.item.Comment) || null,
        ConnectedMPRNs: (this.asset_data && this.asset_data.item.ConnectedMPRNs) || null,
      };
    },
    feeder_names: function () {
      return this.asset_model && this.asset_model.ActiverFeeders
        ? this.asset_model.ActiverFeeders.toString().split("")
        : "000000".split("");
    },
    is_h2scan_user: function () {
      return this.$store.state.tenant_config && this.$store.state.tenant_config.powerdata_type
        ? this.$store.state.tenant_config.powerdata_type == "h2scan"
        : false;
    },
  },
};
</script>
<style lang="scss" scoped>
.opaque {
  opacity: 0.7;
}

.theme--light.v-input input {
  color: var(--v-vtred-base) !important;
}
</style>
